import React from 'react';
import Modal from 'react-responsive-modal';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button } from '@synergy-marine-group/synergy-ui';
import { ppeComponentModalStyles } from '../Modal/styles';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import { DropdownWithCheckboxes } from './DropdownWithCheckboxes';
import getVesselList from './queries/getVesselList';
import formatDropdownVesselGroup from '../../utils/formatDropDownVesselGroup';
import createPpeVesselGroup from './queries/createGroupList';
import updateVesselGroupList from './queries/updateVesselGroupList';
import ConfirmDelete from '../Modal/ConfirmDelete';

const AddVesselGroup = ({ modal, setModal, items, setItems, mode, setMode, policies }) => {
 const validationSchema = Yup.object({
    vesselGroupName: Yup.string()
        .trim()
        .required('Please enter the Vessel Group Name')
        .max(128, 'Vessel Group Name must not exceed 128 characters'),
    vesselIds: mode === 'add'
      ? Yup.array().min(1, 'Please select at least one vessel')
      : Yup.array()
  });
    const dataone = {
      Page: 1,
      PageSize: 10000,
      searchCriteria: '',
      isAll: true
    };
    const dataTwo = {
      Page: 1,
      PageSize: 10000,
      searchCriteria: '',
      isAll: true,
      vesselGroupId: items?.vesselGroupId ? items?.vesselGroupId : ''
    };
    const { mutate: CreatePpeVesselGroup } = createPpeVesselGroup();
    const { mutate: updateVesselGroup } = updateVesselGroupList();
    const { data: VesselList } = getVesselList(items?.vesselGroupId ? dataTwo : dataone);
    const components = formatDropdownVesselGroup(VesselList?.data?.items, 'vesselName', 'vesselId');
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [groupData, setGroupData] = React.useState(false);

    const handleSubmit = (data) => {
        if (mode === 'add') {
        CreatePpeVesselGroup(data);
        setModal(false);
        setMode('add');
        setItems({
          vesselGroupName: '',
          vesselIds: []
        });
        } else if ((mode !== 'add')) {
        if (data?.vesselIds?.length > 0) {
          updateVesselGroup(data);
          setModal(false);
          setMode('add');
          setItems({
            vesselGroupName: '',
            vesselIds: []
          });
        } else {
          setGroupData(data);
          setDeleteModal(true);
        }
        }
    };
    const confrimDelete = () => {
      setDeleteModal(false);
      updateVesselGroup(groupData);
      setModal(false);
      setMode('add');
      setItems({
        vesselGroupName: '',
        vesselIds: []
      });
    };
    const cancelModal = () => {
      setDeleteModal(false);
    };
    return (
    <div className="modal-content add-vesse-group-root">
       {deleteModal && (
        <ConfirmDelete
          modal={deleteModal}
          setModal={setDeleteModal}
          handleDelete={confrimDelete}
          handleCancel={cancelModal}
          message="Update"
          subMessage="This will remove the vessel group since no vessels are mapped."
        />
      )}
    <Modal
    open={modal}
    onClose={() => {
      setModal(false);
      setItems({
        vesselGroupName: '',
        vesselIds: []
    });
    }}
    closeOnOverlayClick
    showCloseIcon={false}
    blockScroll={false}
    focusTrapped={false}
    modal={
        { ...ppeComponentModalStyles.modal,
        overflow: 'visible',
        maxHeight: '90vh'
        }
      }
    styles={ppeComponentModalStyles}
    center
    >
      <div className="uppercase text-center font-bold text-xl pb-5 font-montserrat">
        {mode === 'add' ? 'Add Vessel Group' : 'Edit Vessel Group'}
      </div>
      <Formik
        initialValues={items}
        onCancel={() => {
          setModal(false);
          setItems({
            vesselGroupName: '',
            vesselIds: []
        });
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {() => {
            return (
        <Form>
    <div className="w-auto ">
            <div className="align-middle align-center">
        <div className="grid grid-cols-2 gap-4 newDataError">
        <div className="col-span-2">
                  <Field
                    name="vesselGroupName"
                    component={InputFieldComponent}
                    className="w-full"
                    size="large"
                    rounded
                    requiredField
                    id="vesselGroupName"
                    type="text"
                    label="Vessel Group Name"
                    maxLength={250}
                  />
         <div className="mt-3">
         <label className=" text-gray-100 p-1 block text-sm font-muli text-left input-label">Map Vessels</label>
         </div>
        <Field
            name="vesselIds"
            label=""
            requiredField
            component={DropdownWithCheckboxes}
            options={components}
        />
        </div>
        </div>
            </div>
          <div className="flex justify-end pt-8">
            <Button
              className="max-w-none mr-4 font-montserrat text-gray-500 uppercase text-sm"
              onClick={() => {
                setModal(false);
                setItems({
                  vesselGroupName: '',
                  vesselIds: []
              });
              }}
              size="small"
              variant="outlined"
              rounded
              type="reset"
            >
              Discard
            </Button>

            <Button
            className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
            size="small"
            variant=" filled"
            rounded
            disabled={!policies?.ppePolicies.canEdit}
            type="submit"
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
          </div>
    </div>
        </Form>
        );
}}
      </Formik>
    </Modal>
    </div>
  );
};

export default AddVesselGroup;
